import TextComponent from 'app_components/commons/TextComponent/TextComponent'
import CourseService from 'app_services/campus/academic/courseService'
import { routingService } from 'app_services/routingService'
import { ICourseSchedulingListItem } from 'app_types/admin/courseScheduling/courseSchedulingTypes'
import React, { FC, useCallback, useEffect, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import StudentRelatedCourseItem from '../StudentRelatedCourseItem/StudentRelatedCourseItem'

import './StudentDashboardRelatedCourses.scss'

interface IStudentDashboardRelatedCoursesProps {
  id?: string
}

const StudentDashboardRelatedCourses: FC<IStudentDashboardRelatedCoursesProps> = ({ id }) => {
  const [courses, setCourses] = useState<ICourseSchedulingListItem[]>([])
  const courseService = useMemo(() => new CourseService(), [])

  const getCourses = useCallback(async () => {
    let httpParams: any = {
      pageNumber: 1,
      startDate: {
        date: 'today',
        direction: 'gte'
      },
      random: {
        size: 4
      },
      highlighted: true,
      publish: true,
    }

    const coursesResponse = await courseService.fetchCourses(httpParams)
    if (coursesResponse && coursesResponse.courses) {
      return setCourses(coursesResponse.courses as unknown as ICourseSchedulingListItem[]);
    }
    return setCourses([])
  }, [courseService])

  useEffect(() => {
    getCourses()
  }, [getCourses])

  return (
    <div id={id} className="student-dashboard-related-courses--layout">
      <TextComponent type="subtitle">
        Cursos relacionados
      </TextComponent>
      <TextComponent color="#42474E">
        Completa tu formación con:
      </TextComponent>
      <div className="student-dashboard-related-courses--list">
        {courses?.map((course) => (
          <Link key={course._id} to={routingService.getPublicPath(`/curso/${course._id}`)}>
            <StudentRelatedCourseItem course={course} />
          </Link>
        ))}
      </div>
    </div>
  )
}

export default StudentDashboardRelatedCourses
